import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { TicketComponent } from './ticket.component';
import { ReportingGuard } from 'src/app/guards/reporting.guard';
import { MeasureEditComponent } from './measure-edit/measure-edit.component';
import { BankDetailsEditComponent } from './bank-details-edit/bank-details-edit.component';
import { PartPaymentEditComponent } from './part-payment-edit/part-payment-edit.component';
import { InquiryEditComponent } from './inquiry-edit/inquiry-edit.component';
import { RelocationEditComponent } from './relocation-edit/relocation-edit.component';
import { SignUpEditComponent } from './sign-up-edit/sign-up-edit.component';
import { PhotovoltaikEditComponent } from './photovoltaik-edit/photovoltaik-edit.component';
import { MasterdataEditComponent } from './masterdata-edit/masterdata-edit.component';
import { RelocationV2EditComponent } from './relocation-v2-edit/relocation-v2-edit.component';

const routes: Routes = [
  {
    path: '',
    component: TicketComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: ':tid/measure',
    component: MeasureEditComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: ':tid/bank_details',
    component: BankDetailsEditComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: ':tid/part_payment',
    component: PartPaymentEditComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: ':tid/inquiry',
    component: InquiryEditComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: ':tid/relocation',
    component: RelocationEditComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: ':tid/relocation_v2',
    component: RelocationV2EditComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: ':tid/masterdata',
    component: MasterdataEditComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: ':tid/sign_up',
    component: SignUpEditComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: ':tid/photovoltaics',
    component: PhotovoltaikEditComponent,
    canActivate: [ReportingGuard]
  }
]

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes),
    CommonModule
  ],
  exports: [RouterModule],
})
export class TicketModule { }
